import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './local';
import './i18n';
import './portal.css';

import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
